module.exports = __webpack_public_path__ + "static/img/cstSer_bg_10.37b26a88.svg";